var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.variationListData, function(variation) {
        return [
          variation.variationId === _vm.currentVariation.variation.id &&
          variation.stock.stockNet <= 10
            ? _c("p", [
                _vm._v(
                  "\n            Nur noch " +
                    _vm._s(variation.stock.stockNet) +
                    " auf Lager\n        "
                )
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }